import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-processing',
  templateUrl: './data-processing.component.html',
  styleUrls: ['./data-processing.component.scss']
})
export class DataProcessingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
